import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { toast } from "react-toastify";
import MediaQuery from "react-responsive";
import Swal from "sweetalert2";

import {
  DataTable,
  TableRowField,
  MainLoader,
  ExportCSV,
} from "../../../../components";
import { selectUserRole } from "../../../../store/user/selector";
import { roles, layout } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";

import {
  getOffers,
  deleteOffer,
  resetOffers,
} from "../../../../store/offer/actions";
import { getOffers as allOffersExport } from "../../../../service/offer";
import { exportExcel } from "./excel";

class OfferList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      loadingExport: false,
    };
    this.handleObtainOffersExport = this.handleObtainOffersExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.performGetOffers(true);
  }

  componentWillUnmount() {
    this.props.resetOffers();
  }

  componentDidUpdate(prevProps) {
    this.checkOfferDelete(prevProps);
  }

  performGetOffers(reset = false) {
    const { page, filter } = this.state;

    this.props.getOffers({ page, filter, reset });
  }

  performDeleteOffer(id) {
    Swal({
      title: "Eliminar Oferta",
      text: "¿Estás seguro que deseas eliminar la oferta?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteOffer(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetOffers();
  }

  async filterOffers() {
    await this.setState({ page: 1 });
    this.performGetOffers();
  }

  async handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterOffers();
    }
  }

  async checkOfferDelete(prevProps) {
    if (prevProps.deletedOffer == null && this.props.deletedOffer != null) {
      toast.success("Oferta eliminada satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetOffers();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.SUPER_ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/offers/${row.id}/detail`
                )
              }
            >
              <i className="mr-1 fa fa-eye"></i> Detalle
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(`/administration/offers/${row.id}/edit`)
              }
            >
              <i className="mr-1 fa fa-edit"></i> Editar
            </DropdownItem>
            <DropdownItem
              disabled={this.props.deleteLoading}
              onClick={() => this.performDeleteOffer(row.id)}
            >
              <i className="mr-1 fa fa-trash"></i> Eliminar
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    } else {
      return (
        <Button
          type="button"
          color="primary"
          size="sm"
          onClick={() =>
            this.props.history.push(`/administration/offers/${row.id}/detail`)
          }
        >
          <i className="fa fa-eye"></i>
        </Button>
      );
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.offers}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  async handleObtainOffersExport() {
    this.setState({ loadingExport: true });
    allOffersExport(0, null)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Oferta",
        formatter: (cell, row) => {
          const aux = new Date(row.expirationDate);
          aux.setHours(aux.getHours() - 5);
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField
                label="Fecha de Inicio:"
                value={formatHelper.toDateDDMMYYY(row.startDate)}
              />
              <TableRowField
                label="Fecha de Expiración:"
                value={formatHelper.toDateDDMMYYY(aux)}
              />
              <TableRowField
                label="Precio Total (S/):"
                value={formatHelper.toMoney(row.total_price)}
              />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "xs",
        text: "Oferta",
        formatter: (cell, row) => {
          const aux = new Date(row.expirationDate);
          aux.setHours(aux.getHours() - 5);
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField
                label="Fecha de Inicio:"
                value={formatHelper.toDateDDMMYYY(row.startDate)}
              />
              <TableRowField
                label="Fecha de Expiración:"
                value={formatHelper.toDateDDMMYYY(aux)}
              />
            </div>
          );
        },
      },
      {
        dataField: "total_price",
        text: "Precio Total(S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      columnOption,
    ];
    const columns = [
      {
        dataField: "name",
        text: "Nombre",
        formatter: (cell) => {
          return <span>{cell}</span>;
        },
      },
      {
        dataField: "startDate",
        text: "Fecha de Inicio",
        formatter: (cell) => {
          return <span>{formatHelper.toDateDDMMYYY(cell)}</span>;
        },
      },
      {
        dataField: "expirationDate",
        text: "Fecha de Expiración",
        formatter: (cell) => {
          const aux = new Date(cell);
          aux.setHours(aux.getHours() - 5);

          return <span>{formatHelper.toDateDDMMYYY(aux)}</span>;
        },
      },
      {
        dataField: "total_price",
        text: "Precio Total(S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      columnOption,
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-layers"></i>Ofertas
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="8">
                        <Row>
                          <Col>
                            <InputGroup>
                              <Input
                                type="text"
                                id="input1-group2"
                                name="input1-group2"
                                placeholder="Buscar"
                                value={this.state.filter}
                                onChange={(e) =>
                                  this.setState({
                                    filter: e.target.value,
                                  })
                                }
                                onKeyPress={this.handleInputFilterChange}
                              />
                              <div className="input-group-prepend">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => this.filterOffers()}
                                >
                                  <i className="fa fa-search"></i>
                                </Button>
                              </div>
                            </InputGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="4">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainOffersExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="5">
                        <Row>
                          <Col>
                            <InputGroup>
                              <Input
                                type="text"
                                id="input1-group2"
                                name="input1-group2"
                                placeholder="Buscar"
                                value={this.state.filter}
                                onChange={(e) =>
                                  this.setState({
                                    filter: e.target.value,
                                  })
                                }
                                onKeyPress={this.handleInputFilterChange}
                              />
                              <div className="input-group-prepend">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => this.filterOffers()}
                                >
                                  <i className="fa fa-search"></i>
                                </Button>
                              </div>
                            </InputGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainOffersExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {this.props.role == roles.SUPER_ADMIN && (
              <Row className="mb-2">
                <Col>
                  <div className="float-right">
                    <Button
                      color="primary"
                      onClick={() =>
                        this.props.history.push("/administration/offers/add")
                      }
                    >
                      <i className="mr-1 fa fa-plus"></i> Nuevo
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { offers, error, loading, pageSize, total } = state.offer.offersList;

  return {
    offers,
    error,
    loading,
    pageSize,
    total,

    role: selectUserRole(state),

    deletedOffer: state.offer.deleteOffer.offer,
    deleteError: state.offer.deleteOffer.error,
    deleteLoading: state.offer.deleteOffer.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getOffers,
      deleteOffer,
      resetOffers,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferList/OfferList.js